<template>
    <NavbarComp />
    <div id="main">
        <div id="first-section">
            <div id="left">
                <h3>Bootcamp Data Science</h3>
                <p class="mb-md-4 mb-lg-5">
                    Jadilah profesional Data Science dan raih karir terbaik di perusahaan keinginanmu!!
                </p>
                <!-- <h4> 20 Session + 3 Career Coaching | 8 Weeks </h4> -->
                <p id="harga">Harga : </p>
                <h4>Rp 3.000.000,00</h4>
                <!-- <h5>Rp. 3.000.000,00</h5>
                <h6>Dapatkan harga khusus diskon up to 50% buat pendaftar hari ini.</h6> -->
                <button id="btnDaftar" value="daftar" @click="gotoDaftar()">Daftar Sekarang</button>
                <p class="nb-text">*Harga khusus diskon up to 50% buat pendaftar hari ini</p>
            </div>
            <div id="right">
                <img src="../assets/imgHeader.png">
            </div>
        </div>
        <div id="second-section">
            <div id="aside">
                <a @click="goto('scroll1')" tabindex="0">Tentang Program</a>
                <a @click="goto('scroll2')" tabindex="0">Benefit Program</a>
                <a @click="goto('scroll3')" tabindex="0">Kurikulum</a>
                <a @click="goto('scroll4')" tabindex="0">Tahap Program</a>
                <a @click="goto('scroll5')" tabindex="0">Mentor</a>
                <a @click="goto('scroll6')" tabindex="0">Biaya</a>
                <a @click="goto('scroll7')" tabindex="0">Jadwal Program</a>
                <a @click="goto('scroll8')" tabindex="0">Alur Pendaftaran</a>
                <a @click="goto('scroll9')" tabindex="0">Testimoni</a>
                <a @click="goto('scroll10')" tabindex="0">FAQ</a>
                <button id="btnDaftar" value="daftar" @click="gotoDaftar()">Daftar Sekarang</button>
            </div>
            <div id="article">
                <div id="tentangProgram">
                    <h4 ref="scroll1">Tentang Program</h4>
                    <h3>Apa itu Bootcamp Data Science?</h3>
                    <div id="isi">
                        <div id="isi1">
                            <img src="../assets/img1.1.png" width="255px">
                            <p>
                                Bootcamp Data Science adalah suatu kegiatan yang di desain khusus untuk kamu yang mau
                                belajar dari 0 terkait Data Science, dimana akan diajari dari penggunaan python basic,
                                pre-processing hingga pemodelan dalam machine learning. Belajar selama 6 minggu dan akan
                                mendapatkan mentoring 1on1 dengan para trainer berpengalaman.
                            </p>
                        </div>
                        <div id="isi2">
                            <img src="../assets/img1.2.png" width="255px">
                            <p>
                                Tidak hanya itu, kamu juga akan dibekali dengan teori-teori penunjang data science yang
                                akan mendukung praktikum yang ada. Serta softskill yang akan membantu kamu dalam public
                                speaking, komunikasi dan personal branding. Serta akan ada job connector dari Intelligo
                                ID.
                            </p>
                        </div>
                    </div>
                </div>
                <div id="benefitProgram">
                    <h4 ref="scroll2">Benefit Program</h4>
                    <h3>Apa yang kamu dapatkan?</h3>
                    <div id="isi">
                        <div id="isi1">
                            <div id="elemen">
                                <img src="../assets/book.png">
                                <div id="detail">
                                    <h5>Belajar dari Dasar</h5>
                                    <p>
                                        Kamu akan belajar dari dasar. Jadi yang jurusan Non IT jangan takut lagi nih!
                                    </p>
                                </div>
                            </div>
                            <div id="elemen">
                                <img src="../assets/meeting.png">
                                <div id="detail">
                                    <h5>Mentoring 1 on 1</h5>
                                    <p>
                                        Kamu akan mendapatkan kesempatan untuk mentoring 1on1 dengan para trainer.
                                    </p>
                                </div>
                            </div>
                            <div id="elemen">
                                <img src="../assets/certificate.png">
                                <div id="detail">
                                    <h5>Sertifikat Penyelesaian</h5>
                                    <p>
                                        Sertifikat dan hasil nilai yang bisa jadi tolak ukur kemampuan kamu.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="isi2">
                            <div id="elemen">
                                <img src="../assets/portfolio.png">
                                <div id="detail">
                                    <h5>Portofolio</h5>
                                    <p>
                                        Jaminan portofolio yang bisa kamu jadikan branding di sosial media.
                                    </p>
                                </div>
                            </div>
                            <div id="elemen">
                                <img src="../assets/career.png">
                                <div id="detail">
                                    <h5>Career Coaching</h5>
                                    <p>
                                        Professional CV Creation (ATS and Creative), Cover Letter Creation dan LinkedIn
                                        Profile Optimization.
                                    </p>
                                </div>
                            </div>
                            <div id="elemen">
                                <img src="../assets/project-management.png">
                                <div id="detail">
                                    <h5>First Freelance Project Guarantee *</h5>
                                    <p>
                                        Akan dibimbing sampai kamu mendapatkan 1 project pertama secara freelance.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="kurikulum">
                    <h4 ref="scroll3">Kurikulum</h4>
                    <h3>Apa yang dipelajari?</h3>
                    <!-- <div class="dropdown">
                        <div id="isi">
                            <p>Introduction to Data Science</p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Perkenalan, Introduction to Data, Introduction to Data Science, Introduction to Python,
                                IDE Python, Coding style, Tools Installation.
                            </p>
                        </div>
                    </div>
                    <div class="dropdown">
                        <div id="isi">
                            <p>Python Basic</p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Variabel dan tipe data, Input output, Logika/kondisi IF - Else, Function Def, Tipe data
                                list, Pengenalan Statistik, Statistik Dasar, Looping, Operator, Perbandingan, Library,
                                Library Pandas, Library Regex, Library Matplotlib, Library Seaborn, Exploratory Data
                                Analysis (EDA), Studi Kasus EDA, Anonymous Function, Built in Function, Object-oriented
                                programming (OOP), Mini Program.
                            </p>
                        </div>
                    </div>
                    <div class="dropdown">
                        <div id="isi">
                            <p>Machine Learning - 1</p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Introduction to Machine Learning, Supervised Learning, Classification, Scikit-Learn,
                                Studi Kasus Classification, Scraping Data - Selenium, Natural Language Processing (NLP).
                            </p>
                        </div>
                    </div>
                    <div class="dropdown">
                        <div id="isi">
                            <p>Machine Learning - 2</p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Regression, Uji asumsi klasik regression data, Studi Kasus Regression
                            </p>
                        </div>
                    </div>
                    <div class="dropdown">
                        <div id="isi">
                            <p>Machine Learning - 3</p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Hyperparameter tuning, Handling Imbalance Data, Evaluation Method.
                            </p>
                        </div>
                    </div>
                    <div class="dropdown">
                        <div id="isi">
                            <p>Final Project</p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Forum Group Discussion, Mentoring for final project, presentation, Graduates !
                            </p>
                        </div>
                    </div>
                    <div class="dropdown">
                        <div id="isi">
                            <p>Career Coaching</p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Professional CV Creation (ATS and Creative), Cover Letter Creation dan LinkedIn Profile
                                Optimization.
                            </p>
                        </div>
                    </div> -->
                    <div class="accordion accordion-flush" id="kurikulumAccordion">
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kurikulumOne" aria-expanded="false" aria-controls="kurikulumOne">
                                    Introduction to Data Science
                                </button>
                            </h2>
                            <div id="kurikulumOne" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingOne" data-bs-parent="#kurikulumAccordion">
                                <div class="accordion-body">
                                    Perkenalan, Introduction to Data, Introduction to Data Science, Introduction to Python, IDE Python, Coding style, Tools Installation.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kurikulumTwo" aria-expanded="false" aria-controls="kurikulumTwo">
                                    Python Basic
                                </button>
                            </h2>
                            <div id="kurikulumTwo" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingTwo" data-bs-parent="#kurikulumAccordion">
                                <div class="accordion-body">
                                    Variabel dan tipe data, Input output, Logika/kondisi IF - Else, Function Def, Tipe data list, Pengenalan Statistik, Statistik Dasar, Looping, Operator, Perbandingan, Library, Library Pandas, Library Regex, Library Matplotlib, Library Seaborn, Exploratory Data Analysis (EDA), Studi Kasus EDA, Anonymous Function, Built in Function, Object-oriented programming (OOP), Mini Program. 
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kurikulumThree" aria-expanded="false" aria-controls="kurikulumThree">
                                    Machine Learning - 1
                                </button>
                            </h2>
                            <div id="kurikulumThree" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingThree" data-bs-parent="#kurikulumAccordion">
                                <div class="accordion-body">
                                    Introduction to Machine Learning, Supervised Learning, Classification, Scikit-Learn, Studi Kasus Classification, Scraping Data - Selenium, Natural Language Processing (NLP). 
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kurikulumFour" aria-expanded="false" aria-controls="kurikulumFour">
                                    Machine Learning - 2
                                </button>
                            </h2>
                            <div id="kurikulumFour" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingThree" data-bs-parent="#kurikulumAccordion">
                                <div class="accordion-body">
                                    Regression, Uji asumsi klasik regression data, Studi Kasus Regression 
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kurikulumFive" aria-expanded="false" aria-controls="kurikulumFive">
                                    Machine Learning - 3
                                </button>
                            </h2>
                            <div id="kurikulumFive" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingThree" data-bs-parent="#kurikulumAccordion">
                                <div class="accordion-body">
                                    Hyperparameter tuning, Handling Imbalance Data, Evaluation Method. 
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kurikulumSix" aria-expanded="false" aria-controls="kurikulumSix">
                                    Final Project
                                </button>
                            </h2>
                            <div id="kurikulumSix" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingThree" data-bs-parent="#kurikulumAccordion">
                                <div class="accordion-body">
                                    Forum Group Discussion, Mentoring for final project, presentation, Graduates ! 
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kurikulumSeven" aria-expanded="false" aria-controls="kurikulumSeven">
                                    Career Coaching
                                </button>
                            </h2>
                            <div id="kurikulumSeven" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingThree" data-bs-parent="#kurikulumAccordion">
                                <div class="accordion-body">
                                    Professional CV Creation (ATS and Creative), Cover Letter Creation dan LinkedIn Profile Optimization. 
                                </div>
                            </div>
                        </div>
                    </div>  
                </div>
                <div id="tahapanProgram">
                    <h4 ref="scroll4">Tahapan Program</h4>
                    <h3>Apa yang Anda lewatkan dalam program ini?</h3>
                    <div id="isi">
                        <h5>Introduction</h5>
                        <p>
                            Dalam tahapan ini kamu akan melewati banyak perkenalan awal, dari mulai apa itu data
                            science, python dan penerapan maching learning nantinya.
                        </p>
                    </div>
                    <div id="isi">
                        <h5>Python Basic</h5>
                        <p>
                            Sebagai bahasa pemrograman yang utama, maka kamu diharapkan bisa cukup mahir untuk melewati
                            step ini.
                        </p>
                    </div>
                    <div id="isi">
                        <h5>Machine Learning</h5>
                        <p>
                            Ini tahapan yang sangat penting, karena kamu akan belajar bagaimana penerapan machine
                            learning menggunakan python dan dibantu dengan studi kasus yang sangat lengkap dari
                            supervised learning hingga unsupervised learning.
                        </p>
                    </div>
                    <div id="isi">
                        <h5>Final Project</h5>
                        <p>
                            Tahapan ini adalah langkah akhir untuk menjadi Alumni Bootcamp Data Science Intelligo ID.
                            Karena, kamu akan menjalani yang namanya final project dengan studi kasus yang dirancang
                            khusus untuk kamu gunakan dan menjadi portofolio yang bisa menjadi branding kamu nantinya !
                        </p>
                    </div>
                    <div id="isi">
                        <h5>Career Coaching</h5>
                        <p>
                            Ini adalah tahapan mengembangkan softskill. Selain kamu belajar hardskill, pastinya akan
                            belajar mengenai softskill agar nantinya bisa berkompetisi dengan banyak individu lainnya.
                            1-on-1 yang dilakukan dalam beberapa sesi berturut-turut dengan tujuan membantu kamu
                            menemukan, merencanakan, dan mengembangkan karir yang sesuai dengan passion!
                        </p>
                    </div>
                </div>
                <div id="mentor">
                    <h4 ref="scroll5">Mentor</h4>
                    <h3>Yuk kenali mentor yang akan membimbingmu!</h3>
                    <!--  <div id="isi">
                        <div id="elemen" class="text-center">
                            <img src="../assets/mentor-yudy.png" width="180px">
                            <h5>Yudy Yunardy</h5>
                            <p>
                                Senior Business Analyst Indivara Group, Business Analyst Jati Piranti Solusindo, IBM
                                Advanced Data Science certified,
                                Google Data Analytics certified
                            </p>
                            <a href="https://www.linkedin.com/in/yudy-yunardy-4820a620/">
                                <img id="linkedin" src="../assets/linkedin.png">
                            </a>
                        </div>
                        <div id="elemen" class="text-center">
                            <img src="../assets/mentor-fahmi.png" width="180px">
                            <h5>Muhammad Fahmi</h5>
                            <p>
                                Data Scientist <br>at
                                Big Data Tech Company
                            </p>
                            <a href="https://www.linkedin.com/in/muhammad-fahmi17/">
                                <img id="linkedin" src="../assets/linkedin.png">
                            </a>
                        </div>
                        <div id="elemen" class="text-center">
                            <img src="../assets/mentor-helna.png" width="180px">
                            <h5>Helna Freecenta</h5>
                            <p>
                                Data Analyst<br> at Big Media Company
                            </p>
                            <a href="https://www.linkedin.com/in/helna-freecenta/">
                                <img id="linkedin" src="../assets/linkedin.png">
                            </a>
                        </div>
                        <div id="elemen" class="text-center">
                            <img src="../assets/mentor-joko.png" width="180px">
                            <h5>Joko Joko Eliyanto</h5>
                            <p>
                                Data Scientist<br>at Teman Data
                            </p>
                            <a href="https://www.linkedin.com/in/joko-eliyanto-23a1b6143/">
                                <img id="linkedin" src="../assets/linkedin.png">
                            </a>
                        </div>
                        <div id="elemen" class="text-center">
                            <img src="../assets/mentor-nanda.png" width="180px">
                            <h5>Nanda Harsana</h5>
                            <p>
                                Technical Consultant <br>at ISGS
                            </p>
                            <a href="https://www.linkedin.com/in/nanda-harsana-octavya/">
                                <img id="linkedin" src="../assets/linkedin.png">
                            </a>
                        </div>
                    </div> -->
                    <!-- splide -->
                    <Splide :has-track="false" :options="options" @splide:pagination:mounted="onPaginationMounted"
                        aria-label="Splide Mentor">
                        <div class="container">
                            <SplideTrack>
                                <SplideSlide class="margin-0">
                                    <div id="elemen" class="text-center card-mentor">
                                        <img src="../assets/mentor-yudy.png">
                                        <h5>Yudy Yunardy</h5>
                                        <p>
                                            Senior Business Analyst Indivara Group, Business Analyst Jati Piranti
                                            Solusindo, IBM
                                            Advanced Data Science certified,
                                            Google Data Analytics certified
                                        </p>
                                        <a href="https://www.linkedin.com/in/yudy-yunardy-4820a620/">
                                            <img id="linkedin" src="../assets/linkedin.png">
                                        </a>
                                    </div>
                                </SplideSlide>
                                <SplideSlide>
                                    <div id="elemen" class="text-center card-mentor">
                                        <img src="../assets/mentor-fahmi.png">
                                        <h5>Muhammad Fahmi</h5>
                                        <p>
                                            Data Scientist <br>at
                                            Big Data Tech Company
                                        </p>
                                        <a href="https://www.linkedin.com/in/muhammad-fahmi17/">
                                            <img id="linkedin" src="../assets/linkedin.png">
                                        </a>
                                    </div>
                                </SplideSlide>
                                <SplideSlide>
                                    <div id="elemen" class="text-center card-mentor">
                                        <img src="../assets/mentor-helna.png">
                                        <h5>Helna Freecenta</h5>
                                        <p>
                                            Data Analyst<br> at Big Media Company
                                        </p>
                                        <a href="https://www.linkedin.com/in/helna-freecenta/">
                                            <img id="linkedin" src="../assets/linkedin.png">
                                        </a>
                                    </div>
                                </SplideSlide>
                                <SplideSlide>
                                    <div id="elemen" class="text-center card-mentor">
                                        <img src="../assets/mentor-joko.png">
                                        <h5>Joko Joko Eliyanto</h5>
                                        <p>
                                            Data Scientist<br>at Teman Data
                                        </p>
                                        <a href="https://www.linkedin.com/in/joko-eliyanto-23a1b6143/">
                                            <img id="linkedin" src="../assets/linkedin.png">
                                        </a>
                                    </div>
                                </SplideSlide>
                                <SplideSlide>
                                    <div id="elemen" class="text-center card-mentor">
                                        <img src="../assets/mentor-nanda.png">
                                        <h5>Nanda Harsana</h5>
                                        <p>
                                            Technical Consultant <br>at ISGS
                                        </p>
                                        <a href="https://www.linkedin.com/in/nanda-harsana-octavya/">
                                            <img id="linkedin" src="../assets/linkedin.png">
                                        </a>
                                    </div>
                                </SplideSlide>
                            </SplideTrack>
                            <div class="wrapper__splide">
                                <div class="splide__pagination" />

                                <div class="splide__arrows">
                                    <button class="splide__arrow splide__arrow--prev">
                                        <i class="fa-solid fa-circle-arrow-right"></i>
                                    </button>
                                    <button class="splide__arrow splide__arrow--next">
                                        <i class="fa-solid fa-circle-arrow-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Splide>
                </div>
                <div id="biaya">
                    <h4 ref="scroll6">Biaya</h4>
                    <h3>Dengan harga yang pas dan tentunya terjangkau</h3>
                    <div id="isi">

                        <img src="../assets/goodjob-finance.png" class="img-biaya-kiri">
                        <div id="information" class="text-center">
                            <h5>YUK JOIN SEKARANG JUGA!!</h5>
                            <p>Pendaftaran dibuka : 20 Desember 2022 - 12 Februari 2023</p>
                            <p>Kelas Terdekat : 23 Januari 2023 & 13 Februari 2023</p>
                            <p class="text-price">Rp 3.000.000</p>
                            <button id="btnDaftar" value="daftar" @click="gotoKupon()">Dapatkan Kupon</button>
                            <p class="text-discount">
                                *Dapatkan harga khusus diskon up to 50% buat pendaftaran hari ini.
                            </p>
                        </div>
                        <img src="../assets/business-finance.png" class="img-biaya-kanan">
                    </div>
                </div>
                <!-- bagianku -->
                <div id="jadwalProgram">
                    <h4 ref="scroll7">Jadwal Program</h4>
                    <h3>Dengan jadwal yang tepat selama 6 pekan</h3>
                    <div id="isi">
                        <div id="elemen1">
                            <p>Senin</p>
			    <h5>19.30 - 21.30</h5>
                            <h5>Live Session</h5>
                            <p id="detail" style="opacity: 0;">
                                as
                            </p>
                        </div>
                        <div id="elemen2">
                            <p>Selasa</p>
                            <p id="detail">
                                Belajar Mandiri
                            </p>
                        </div>
                        <div id="elemen3">
                            <p>Rabu</p>
                            <h5>19.30 - 21.30</h5>
                            <p id="detail">
                                Live Session
                            </p>
                        </div>
                        <div id="elemen4">
                            <p>Kamis</p>
                            <p id="detail">
                                Belajar Mandiri
                            </p>
                        </div>
                        <div id="elemen5">
                            <p>Jumat</p>
                            <h5>19.30 - 21.30</h5>
                            <p id="detail">
                                Live Session & 1on1 Mentoring
                            </p>
                        </div>
                    </div>

                </div>
                <div id="alurPendaftaran">
                    <h4 ref="scroll8">Alur Pendaftaran</h4>
                    <h3>Yuk cek tahap pendaftaranmu dimana!</h3>
                    <div class="line-container">
                        <div class="line-1"></div>
                        <div class="line-2"></div>
                    </div>
                    <div class="alur-mobile">
                        <img src="../assets/alur-1.svg">
                        <img src="../assets/alur-2.svg">
                        <img src="../assets/alur-3.svg">
                    </div>
                    <!-- 
                    <div id="isi">
                        <div id="elemen1">
                            <p>Step 1</p>
                            <h5>Melakukan Pendaftaran</h5>
                        </div>
                        <div id="elemen2">
                            <p>Step 2</p>
                            <h5>Melakukan Pembayaran</h5>
                        </div>
                        <div id="elemen3">
                            <p>Step 3</p>
                            <h5>Selesai, Admin akan segera proses pendaftaran kamu</h5>
                        </div>
                    </div> -->
                </div>

                <div id="testimoni">
                    <h4 ref="scroll9">Testimoni</h4>
                    <h3>Kata mereka yang sudah mengikuti bootcamp ini</h3>
                </div>
                <!-- <Splide :has-track="false" :options="{ type:loop, perPage: 2, gap: '1em', breakpoints: {
                  770: {
                    perPage: 1,
                
                  },
                  640: {
                    perPage: 1,
              
                  },
                },}" aria-label="My Favorite Images"> -->
                <Splide :has-track="false" :options="options" @splide:pagination:mounted="onPaginationMounted"
                    aria-label="Splide Testimoni" class="splide">
                    <div class="container">
                        <SplideTrack>
                            <SplideSlide class="margin-0">
                                <div class="card border-light">

                                    <div class="row card-judul">
                                        <div class="card-pic1">
                                            <img class="pic1" src="../assets/testi-yasir.png" alt="" />
                                        </div>
                                        <div class="card-name">
                                            <h5 class="card-title">Muhammad Yasir</h5>
                                            <h6 class="card-subtitle mb-2 text-muted">
                                                Alumni Bootcamp Batch 1
                                            </h6>
                                        </div>
                                        <div class="card-rating">
                                            <h6 class="text-rating">4.5</h6>
                                            <img class="star" src="../assets/star.png" alt="" />
                                        </div>
                                    </div>
                                    <p class="card-text">
                                        “Bootcamp di Intelligo ID bagus banget yah,
                                        karena kita belajar dari dasar dan fundamental,
                                        kita juga diberi pilihan materi yang sangat bagus
                                        untuk diterapkan ke Final Project seperti
                                        text mining dan image classification.
                                        Kemudian, dibantu dengan mentoring 1on1 juga serta pembuatan
                                        portfolio untuk personal branding.
                                        Terima kasih intelligo ID ”
                                    </p>

                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div class="card border-light">

                                    <div class="row card-judul">
                                        <div class="card-pic1">
                                            <img class="pic1" src="../assets/testi-ergon.png" alt="" />
                                        </div>
                                        <div class="card-name">
                                            <h5 class="card-title">Ergon Rizky Purba</h5>
                                            <h6 class="card-subtitle mb-2 text-muted">
                                                Alumni Bootcamp Batch 2
                                            </h6>
                                        </div>
                                        <div class="card-rating">
                                            <h6 class="text-rating">4.5</h6>
                                            <img class="star" src="../assets/star.png" alt="" />
                                        </div>
                                    </div>
                                    <p class="card-text">
                                        “Luar biasa, para mentor berusaha ngajar malam hari,
                                        supaya kami bisa ngerti dari awal hingga akhir.
                                        Setelah ikut intelligo ini, saya tertantang untuk mengerjakan project data
                                        science lainnya ! ”
                                    </p>

                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div class="card border-light">

                                    <div class="row card-judul">
                                        <div class="card-pic1">
                                            <img class="pic1" src="../assets/testi-halimul.png" alt="" />
                                        </div>
                                        <div class="card-name ">
                                            <h5 class="card-title">Halimul Hakim Khairul</h5>
                                            <h6 class="card-subtitle mb-2 text-muted">
                                                Alumni Bootcamp Batch 1
                                            </h6>
                                        </div>
                                        <div class="card-rating">
                                            <h6 class="text-rating">4.5</h6>
                                            <img class="star" src="../assets/star.png" alt="" />
                                        </div>
                                    </div>
                                    <p class="card-text">
                                        “Intelligo ID membuat bootcamp menjadi lebih interaktif <br>
                                        karena ada sistem 1on1 yang membantu <br>
                                        kita untuk bertanya sepuasnya. ”
                                    </p>

                                </div>
                            </SplideSlide>

                        </SplideTrack>
                        <div class="wrapper__splide">
                            <div class="splide__pagination" />

                            <div class="splide__arrows">
                                <button class="splide__arrow splide__arrow--prev">
                                    <i class="fa-solid fa-circle-arrow-right"></i>
                                </button>
                                <button class="splide__arrow splide__arrow--next">
                                    <i class="fa-solid fa-circle-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </Splide>
                <div id="faq">
                    <h4 ref="scroll10">FAQ</h4>
                    <!-- <h3>Lorem Ipsum</h3> -->
                    <!-- <div class="dropdown">
                        <div id="isi">
                            <p>
                                Jika saya kuliah atau bekerja apakah saya dapat mengikuti bootcamp dengan waktu yang
                                tepat ?
                            </p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Bisa banget ! karena bootcamp akan dilaksanakan after office hour yaitu malam hari dari
                                jam 19.30 - 21.30.
                            </p>
                        </div>
                    </div>
                    <div class="dropdown">
                        <div id="isi">
                            <p>
                                Jika saya ketinggalan materi, apakah ada video rekaman dan materi yang bisa saya ulang ?
                            </p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Documents dan Recordings setiap harinya bisa di akses oleh peserta untuk di ulang jika
                                mau belajar kembali diluar live session.
                            </p>
                        </div>
                    </div>
                    <div class="dropdown">
                        <div id="isi">
                            <p>
                                Saya non IT, apakah saya bisa mengikuti bootcamp dari dasar banget ?
                            </p>
                            <img src="../assets/down.png">
                        </div>
                        <div class="dropdown-content">
                            <p>
                                Bootcamp di Intelligo ID, diajarin dari 0 dan dasar banget, jadi jangan takut buat kamu
                                yang non IT !
                            </p>
                        </div>
                    </div> -->
                    <div class="accordion accordion-flush" id="faqAccordion">
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faqOne" aria-expanded="false" aria-controls="faqOne">
                                    Jika saya kuliah atau bekerja apakah saya dapat mengikuti bootcamp dengan waktu yang tepat ?
                                </button>
                            </h2>
                            <div id="faqOne" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                                <div class="accordion-body">
                                    Bisa banget ! karena bootcamp akan dilaksanakan after office hour yaitu malam hari dari jam 19.30 - 21.30.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faqTwo" aria-expanded="false" aria-controls="faqTwo">
                                    Jika saya ketinggalan materi, apakah ada video rekaman dan materi yang bisa saya ulang ?
                                </button>
                            </h2>
                            <div id="faqTwo" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                                <div class="accordion-body">
                                    Documents dan Recordings setiap harinya bisa di akses oleh peserta untuk di ulang jika mau belajar kembali diluar live session. 
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-2 rounded-4">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed bg-grey-custom rounded-4 fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faqThree" aria-expanded="false" aria-controls="faqThree">
                                    Saya non IT, apakah saya bisa mengikuti bootcamp dari dasar banget ?
                                </button>
                            </h2>
                            <div id="faqThree" class="accordion-collapse collapse bg-grey-custom rounded-bottom-4" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                                <div class="accordion-body">
                                    Bootcamp di Intelligo ID, diajarin dari 0 dan dasar banget, jadi jangan takut buat kamu yang non IT !
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <FooterComp />
</template>

<script>
import NavbarComp from "../components/NavbarComp.vue";
import FooterComp from "../components/FooterComp.vue";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";

export default {
    name: `DetailEvent`,
    components: {
        Splide,
        SplideSlide,
        SplideTrack,
        NavbarComp,
        FooterComp,
    },
    methods: {
        goto(refName) {
            var element = this.$refs[refName];
            console.log(element);
            var top = element.offsetTop;
            window.scrollTo(0, top);
        },
        gotoDaftar: function () {
            window.open("https://bit.ly/bootcamp-ds-intelligo", "_blank");
        },
        gotoKupon: function () {
            window.open("https://bit.ly/tanya-mintell", "_blank");
        },
        onPaginationMounted(splide, pagination) {
            pagination.items.forEach(function (item) {
                item.button.style.background = "#FCAB97";
            });
        },
    },
    setup() {
        const options = {
            drag: 'free', rewind: false, perPage: 2, perMove: 1, gap: '1em', breakpoints: {
                900: {
                    perPage: 1,
                }
            }
        };
        return { options };
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
body {
    margin: 0;
    background-color: white;
    font-family: 'Poppins', sans-serif;
}

#main {
    display: flex;
    flex-direction: column;
    margin-bottom: 100px;
}

/* ADDITIONAL STYLING */
.bg-grey-custom {
    background-color: #F5F5F5;
}

.rounded-bottom-4 {
    box-shadow: 0 -20px #F5F5F5;
    border-radius: 0 0 1rem 1rem;
}

.accordion-button {
    font-size: 20px;
}

.accordion-body {
    font-size: 18px;
}

.accordion-button:focus {
    color: black !important;
    background-color: #e8e8e8 !important;
    box-shadow: none !important;
}

#first-section {
    /* flex: 20%; */    
    /* flex-direction: row;
    padding-left: 100px;
    margin-left: -1%;
    background-color: #FCAB97; */
    display: flex;
    height: 95vh;
	width: 100%;
	padding: 0 100px;
    background: rgb(252,171,151);
    background: linear-gradient(49deg, rgba(252,171,151,1) 52%, rgba(255,192,176,1) 83%);
}

#first-section #left {
    /* flex: 60%;
    display: flex;
    flex-direction: column;
    padding-top: 200px; */
    align-self: center;
	width: 50%;
}

#first-section h3{
   font-size: 42px;
   font-weight: 600;
   color: #023047;
}

#first-section p {     
   font-size: 18px;
   margin-bottom: 0;
   font-weight: 400;
   color: #02283B;
}

#first-section h6 {
    /* font-size: 16px;
    font-weight: 400;
    color: #02283B;
    width: 650px;
    text-align: justify; */
    font-size: 40px;
    font-weight: 600;
    color: #023047;
}

#first-section .nb-text {     
   font-size: 10px;
   margin-bottom: 0;
   font-weight: 600;
   color: #02283B;
}

#first-section h4 {
    font-size: 28px;
    font-weight: 700;
    color: #FF5400;
}

#first-section button {
    /* width: 220px;
    background-color: #023047;
    font-size: 20px;
    font-weight: 600;
    padding: 18px 10px;
    margin-top: 20px;
    border-radius: 100px;
    color: white;
    cursor: pointer; */
    width: 200px;
    background-color: #023047;
    font-size: 20px;
    font-weight: 600;
    padding: 14px 10px;
    border-radius: 100px;
    border: none;
    color: white;
    cursor: pointer;
    transition: 0.4s;
}

#first-section button:hover {
    background-color: white;
    color: #023047;
    outline-color: #023047;
}

#first-section #right {
    display: flex;
    justify-content: center;
    align-self: flex-end;
    width: 50%;
}

#first-section #right img {
   height: fit-content;
   width: 200%;
   object-fit: cover;
}

/* #first-section img {
    margin-top: 150px;
    width: 545px;
    height: 660px;
    object-fit: cover;
} */

#second-section {
    display: flex;
    flex-direction: row;
}

#second-section #aside {
    flex: 10%;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 10px;
    height: 600px;
    margin-top: 40px;
    margin-left: 100px;
    width: 270px;
    border-radius: 8px;
    border: 1px solid #C2C2C2;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    padding: 32px 40px;
}

#aside {
    position: sticky;
    top: 0;
}

#second-section #aside a {
    margin-top: 15px;
    font-size: 20px;
    color: #023047;
    cursor: pointer;
}

#second-section #aside a:hover {
    color: #FF5400;
}

#second-section #aside button {
    margin-top: 15px;
    width: 200px;
    background-color: #023047;
    font-size: 16px;
    font-weight: 600;
    padding: 18px 10px;
    border-radius: 100px;
    color: white;
    cursor: pointer;
}

#second-section #aside button:hover {
    background-color: white;
    color: #023047;
    outline-color: #023047;
}

#second-section #article {
    flex: 90%;
    display: flex;
    flex-direction: column;
    margin-left: 60px;
}

#article {
    display: flex;
    flex-direction: column;
    /* margin-right: 100px; */
    width: 800px;
    margin-right: 40px;
}

#article #tentangProgram,
#article #benefitProgram,
#article #kurikulum,
#article #tahapanProgram,
#article #mentor,
#article #biaya,
#article #jadwalProgram,
#article #alurPendaftaran,
#article #testimoni,
#article #faq {
    margin-top: 40px;
}

#article #tentangProgram #isi1 {
    display: flex;
    flex-direction: row;
}

#article #tentangProgram #isi2 {
    display: flex;
    flex-direction: row;
    padding-top: 20px;
    padding-left: 80px;
}

#article #tentangProgram p {
    padding-left: 30px;
    text-align: justify;
}

#article #benefitProgram #isi {
    display: flex;
    flex-direction: row;
}

#article #benefitProgram #elemen {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    margin-right: 50px;
    height: 150px;
}

#article #benefitProgram p {
    text-align: justify;
}

#article #benefitProgram img {
    width: 70px;
    height: 70px;
    object-fit: cover;
    margin-right: 20px;
}

#article #benefitProgram h5 {
    font-size: 20px;
    font-weight: 600;
    color: #FF5400;
}

#article #kurikulum {
    display: flex;
    flex-direction: column;
}

#article #kurikulum #isi {
    display: flex;
    flex-direction: row;
    font-size: 24px;
    border-radius: 8px;
    background-color: #F5F5F5;
    padding: 10px 15px;
    margin-bottom: 15px;
    /* width: 97%; */
    cursor: pointer;
}

#article #kurikulum img {
    position: absolute;
    width: 20px;
    height: 12px;
    object-fit: cover;
    margin-top: 15px;
    margin-left: 90%;
}

#article #tahapanProgram {
    margin-right: 10px;
}

#article #tahapanProgram #isi {
    background-color: #F5F5F5;
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 16px 15px;
}

#article #tahapanProgram h5 {
    font-size: 20px;
    font-weight: 600;
    color: #FF5400;
}

#article #tahapanProgram p {
    font-size: 24px;
    text-align: justify;
}

#article #mentor #isi {
    display: flex;
    overflow-x: auto;
}

/* #article #mentor #isi::-webkit-scrollbar {
    width: 0;
} */

/* #article #mentor #elemen {
    min-width: 360px; */
.card-mentor {
    height: 420px;
    display: flex;
    flex-direction: column;
    align-content: space-between;
    align-items: center;
    margin: 5px;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
}
#article #mentor h5 {
    font-size: 24px;
    color: #FF5400;
    font-weight: bold;
    margin: 10px;
}
#article #mentor p {
    font-weight: 500;
}
#article #mentor #linkedin {
    width: 44px;
    height: 44px;
    object-fit: cover;
}

#article #biaya #isi {
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    padding: 15px 32px 20px;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    margin-right: 10px;
}

#article #biaya #information p {
    text-align: center;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    color: #023047;
    margin: 0;
}

#article #biaya #information h5 {
    text-align: center;
    margin: 20px 0;
    font-weight: bold;
    color: #023047;
}

#article #biaya #information button {
    align-self: center;
    width: 320px;
    background-color: #023047;
    font-size: 12px;
    font-weight: 600;
    /* margin: 0 30%; */
    padding: 18px 10px;
    border-radius: 100px;
    color: white;
    cursor: pointer;
}

#article #biaya #information .text-price {
    font-weight: bold;
    margin: 10px 0;
    color: #FF5400;
    font-size: 26px;
}

#article #biaya #information .text-discount {
    color: #FF5400;
    font-size: 12px;
    margin-top: 10px;
}   

#article #jadwalProgram #isi {
    display: flex;
    flex-direction: row;
    /* flex-wrap: wrap; */
    justify-content: center;
}

#article #jadwalProgram #elemen1,
#article #jadwalProgram #elemen2,
#article #jadwalProgram #elemen3,
#article #jadwalProgram #elemen4,
#article #jadwalProgram #elemen5 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 15px;
    text-align: center;
    width: 33.33%;
}

#article #jadwalProgram #elemen1 {
    background-color: #FECCA7;
    border-radius: 8px 0 0 8px;
}

#article #jadwalProgram #elemen2 {
    background-color: #F7B79D;
}

#article #jadwalProgram #elemen3 {
    background-color: #BDA79E;
    border-radius: 0 8px 8px 0;
}

#article #jadwalProgram #elemen4 {
    background-color: #FFDDCC;
    border-radius: 0 8px 8px 0;
}

#article #jadwalProgram #elemen5 {
    background-color: #ABBAC2;
    border-radius: 0 8px 8px 0;
}

#article #jadwalProgram #desc {
    text-align: justify;
}

#article #jadwalProgram p {
    text-align: center;
    font-size: 20px;
}

#article #jadwalProgram p span {
    font-weight: 600;
}

#article #jadwalProgram h5 {
    margin: 10px 0;
    font-size: 20px;
    font-weight: 700;
}

#article #jadwalProgram #detail {
    text-align: center;
}

#article #alurPendaftaran #isi {
    display: flex;
    flex-direction: row;
}

#article #alurPendaftaran #elemen1,
#article #alurPendaftaran #elemen2,
#article #alurPendaftaran #elemen3 {
    flex: 33%;
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 20px 15px;
}

#article #alurPendaftaran #elemen1 {
    background-color: #FFC6AA;
    border-radius: 8px 0 0 8px;
}

#article #alurPendaftaran #elemen2 {
    background-color: #ABBAC2;
}

#article #alurPendaftaran #elemen3 {
    background-color: #DDFAA3;
    border-radius: 0 8px 8px 0;
}

#article #alurPendaftaran p {
    font-size: 20px;
}

#article #alurPendaftaran h5 {
    margin: 10px 0;
    font-size: 20px;
    font-weight: 700;
}

#article #alurPendaftaran #detail {
    text-align: justify;
}

#article #faq {
    display: flex;
    flex-direction: column;
    margin-bottom: 200px;
}

#article #faq #isi {
    display: flex;
    flex-wrap: wrap;
    font-size: 24px;
    border-radius: 8px;
    background-color: #F5F5F5;
    padding: 10px 15px;
    margin-bottom: 15px;
    /* width: 97%; */
    cursor: pointer;
}

#article #faq img {
    position: absolute;
    width: 20px;
    height: 12px;
    object-fit: cover;
    margin-top: 15px;
    margin-left: 90%;
}

/* Alur Pendaftaran */
.alur-mobile {
    /* display: none; */
    margin-bottom: 40px;
}

.line-container {
    position: relative;
}

.line-1,
.line-2 {
    background-color: #FF5400;
    width: 220px;
    height: 1px;
    position: absolute;
    top: 15px;
}

.line-1 {
    right: 220px;
}

.line-2 {
    left: 180px;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown p {
    text-align: justify;
    width: 90%;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
    display: none;
    position: absolute;
    background-color: #ddd;
    width: 100%;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content p {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    text-align: justify;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown:hover {
    margin-bottom: 150px;
}

#article h4 {
    /* margin-top: 40px; */
    font-size: 26px;
    font-weight: 600;
    color: #FF5400;
}

#article h3 {
    font-size: 32px;
    font-weight: 700;
    color: #023047;
}

.isi-card {
    margin-left: 116px;
    margin-right: 116px;
}

.card {
    border-radius: 16px;
    padding: 16px;
    margin-left: 0;
    height: 280px;
    width: 100%;
}

.card-body {
    height: 300px;
}

.card-judul {
    display: flex;
}

.card-title {
    font-weight: 600;
    font-size: 17px;
    color: #050810;
    width: 220px;
}

.card-subtitle {
    font-weight: 400;
    font-size: 13px;
    color: #848484;
}

.card-pic1 {
    width: 15%;
}

.card-name {
    margin-top: 5px;
    width: 65%;
}
.card-rating {
    margin-top: 15px;
    font-weight: 500;
    font-size: 15px;
    color: #050810;
    display: flex;
    width: 15%;
    text-align: left;
    padding-right: 0;
}

.card-text {
    margin-top: 18px;
    font-weight: 400;
    font-size: 15px;
    color: #050810;
}

.star {
    width: 24px;
    height: 24px;
}

.text-rating {
    margin-top: 4px;
}

.pic1 {
    width: 52px;
    border-radius: 100%;
}

.link-page {
    margin-left: 116px;
    margin-bottom: 100px;
}

.page1 {
    width: 30px;
    height: 10px;
    background: #f94f25;
    border-radius: 100px;
    margin-left: 3px;
}

.page {
    width: 10px;
    height: 10px;
    margin-left: 3px;
}

.wrapper__splide {
    height: 2em;
    display: flex;
    justify-content: space-between;
    margin-top: 1em;
    width: 100%;
}

.splide__arrows {
    position: relative;
    display: flex;
    align-items: center;
}

.splide__arrow {
    position: static !important;
    transform: translateY(0) !important;
    margin-right: 8px;
}

.splide__arrow--next,
.splide__arrow--prev {
    color: #f94f25;
    background-color: #fedcd3 !important;
}
.splide__arrow--next :hover {
    opacity: 2;
}
.splide__pagination--custom {
    background-color: #FCAB97 !important;
}
.splide__pagination {
    position: static !important;
    justify-content: start !important;
}
.margin-0 {
    margin: 0;
}

@media only screen and (min-height: 900px) {
    #first-section {
        height: 480px;
    }

    #first-section #right img {
        width: 200% !important;
    }
}

@media only screen and (max-width: 1500px) {

    #first-section p,
    h6 {
        font-size: 16px;
        width: 550px;
    }

    /* #first-section img {
        margin-top: 100px;
    } */

    #second-section #aside {
        margin-left: 100px;
        width: 240px;
        padding: 32px 40px;
    }

    #second-section #aside a {
        margin-top: 15px;
        font-size: 18px;
    }

    #second-section #aside button {
        width: 170px;
    }

    #second-section #article {
        margin-left: 40px;
    }

    #article {
        width: 60%;
    }

    .img-biaya-kiri,
    .img-biaya-kanan {
        width: 150px;
    }
}

@media only screen and (max-width: 1100px) {
    #first-section {
        margin-top: 50px;
        padding-left: 70px;
        padding: 0 70px;
    }

    #first-section h3 {
        font-size: 28px;
    }

    #first-section h4 {
        font-size: 24px;
    }

    #first-section p,
    h6 {
        font-size: 16px;
        width: 430px;
    }

    /* #first-section img {
        margin-top: 150px;
        width: 450px;
        height: 565px;
        object-fit: cover;
    } */

    #second-section #aside {
        margin-left: 70px;
    }

    #article #benefitProgram #elemen {
        height: 160px;
    }

    #article #benefitProgram p {
        font-size: 12px;
        text-align: justify;
    }

    #article #benefitProgram h5 {
        font-size: 18px;
    }

    #article #tentangProgram img {
        width: 235px;
        height: 181px;
        object-fit: cover;
    }

    .accordion-button {
        font-size: 18px;
    }

    .accordion-body {
        font-size: 16px;
    }

    #article #biaya #information button {
        width: 320px;
        /* margin-left: 150px; */
    }

    .img-biaya-kiri {
        display: none;
    }

    .img-biaya-kanan {
        width: 150px;
    }

    .dropdown:hover {
        margin-bottom: 170px;
    }
}

@media only screen and (max-width: 900px) {
    #article #jadwalProgram #elemen1,
    #article #jadwalProgram #elemen2,
    #article #jadwalProgram #elemen3,
    #article #jadwalProgram #elemen4,
    #article #jadwalProgram #elemen5 {
        width: 100%;
        text-align: center;
    }

    .alur-mobile {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .line-1,
    .line-2 {
        display: none;
    }

    #first-section {
        height: 480px;
        padding: 0 70px;
    }

    #first-section h3 {
        font-size: 28px;
    }

    #first-section h4 {
        font-size: 22px;
    }

    #first-section p,
    h6 {
        font-size: 14px;
        width: 310px;
    }

    #first-section h4 {
        font-size: 18px;
    }

    #first-section button {
        font-size: 18px;
    }

    /* #first-section img {
        margin-top: 160px;
        width: 400px;
        height: 515px;
        object-fit: cover;
    } */

    #second-section #aside {
        margin-left: 70px;
        padding: 20px 18px;
    }

    #second-section #aside a {
        font-size: 16px;
        margin-top: 12px;
    }

    #second-section #aside button {
        margin-top: 12px;
        width: 160px;
        font-size: 16px;
    }

    #second-section #article {
        margin-left: 40px;
    }

    #article #tentangProgram #isi1 {
        display: flex;
        flex-direction: column;
    }

    #article #tentangProgram #isi2 {
        display: flex;
        flex-direction: column;
        padding-left: 0;
    }

    #article #tentangProgram p {
        padding-left: 0;
        padding-top: 12px;
    }

    #article #benefitProgram img {
        width: 56px;
        height: 56px;
    }

    #article #benefitProgram #isi {
        display: flex;
        flex-direction: column;
    }

    #article #benefitProgram #elemen {
        height: 120px;
    }

    #article #biaya #information h5 {
        font-size: 28px;
    }

    #article #biaya #information button {
        width: 320px;
        /* margin-left: 0; */
    }

    #article p,
    #article #tahapanProgram p,
    #article #alurPendaftaran p {
        font-size: 14px;
    }

    #article #jadwalProgram p {
        font-size: 20px;
        text-align: center;
    }
    
    #article #jadwalProgram h5,
    #article #alurPendaftaran h5 {
        margin-top: 0px;
        font-size: 18px;
    }

    #article h4 {
        /* margin-top: 40px; */
        font-size: 20px;
        font-weight: 600;
        color: #FF5400;
    }

    #article h3 {
        font-size: 22px;
        font-weight: 700;
        color: #023047;
    }

    .dropdown:hover {
        margin-bottom: 170px;
    }

    /* .img-biaya-kanan {
        display: none;
    }

    .img-biaya-kiri {
        width: 150px;
        display: block;
    } */

    #article #biaya #isi {
        padding: 15px;
        display: block;
        text-align: center;
    }

    .img-biaya-kiri {
        display: none;
    }

    .img-biaya-kanan {
        display: block;
        width: 150px;
        margin: 0 auto;
    }
}
@media only screen and (max-width: 720px) {
    .line-1,
    .line-2 {
        display: none;
    }

    #first-section {
        margin-top: 80px;
    }

    #first-section #left .nb-text {
        font-size: 7px;
    }

    #first-section #right img {
        width: 150%;
    }

    #jadwalProgram #isi div p,
    #jadwalProgram #isi div h5 {
        margin: 0 auto 10px;
    }

    #biaya #isi {
        display: flex;
        flex-direction: column;
    }

    .img-biaya-kiri {
        display: none;
    }

    .img-biaya-kanan {
        display: block;
        width: 150px;
        margin: 0 auto;
    }

    .card-mentor p {
        font-size: 12px;
    }

    .card-mentor img {
        width: 50%;
    }
}
@media only screen and (max-width: 700px) {
    #first-section {
        padding: 0 50px;
    }

    #first-section h3 {
        font-size: 18px;
    }

    #first-section h4 {
        font-size: 16px;
    }

    #first-section p,
    h6 {
        font-size: 14px;
        width: 270px;
    }

    #first-section h4 {
        font-size: 16px;
    }

    #first-section button {
        font-size: 16px;
        padding: 9px 5px;
        width: 170px;
    }

    /* #first-section img {
        margin-top: 230px;
        width: 300px;
        height: 415px;
        object-fit: cover;
    } */

    #second-section #aside {
        margin-left: 30px;
        padding: 10px 9px;
        height: 420px;
    }

    #second-section #aside a {
        font-size: 14px;
        margin-top: 10px;
    }
    
    #second-section #aside button {
        margin-top: 12px;
        width: 150px;
        font-size: 14px;
    }

    #second-section #article {
        margin-left: 20px;
        margin-right: 30px;
    }

    #article #tentangProgram #isi1 {
        display: flex;
        flex-direction: column;
    }

    #article #tentangProgram #isi2 {
        display: flex;
        flex-direction: column;
        padding-left: 0;
    }

    #article #tentangProgram p {
        padding-left: 0;
    }

    #article #benefitProgram #isi {
        display: flex;
        flex-direction: column;
    }

    #article #biaya #information h5 {
        font-size: 18px;
    }

    #article #biaya #information button {
        width: 200px;
        /* margin-left: 10%; */
    }

    #article #biaya,
    #jadwalProgram,
    #alurPendaftaran {
        width: 95%;
    }

    #elemen1,
    #elemen2,
    #elemen3,
    #elemen4,
    #elemen5 {
        border-radius: 8px;
    }

    #article #jadwalProgram #isi,
    #article #alurPendaftaran #isi {
        display: flex;
        flex-direction: column;
    }

    #article h4 {
        /* margin-top: 40px; */
        font-size: 16px;
        font-weight: 600;
    }

    #article h3 {
        font-size: 18px;
        font-weight: 700;
    }

    #article p {
        font-size: 14px;
    }

    .dropdown:hover {
        margin-bottom: 200px;
    }
}
@media only screen and (max-width: 550px) {
        #first-section {
        height: 93vh;
        padding: 0 20px;
    }
    #first-section #left {
        width: 100%;
    }
    #first-section #left h3{
        font-size: 32px;
    }
    #first-section #left p {
        font-size: 16px;
        width: 95%;
    }
    #first-section #left h6 {
        font-size: 10px;
        width: 200px;
    }
    #first-section #left #harga {
        margin-top: 18px;
    }
    #first-section #left h4 {
        font-size: 22px;
    }
    #first-section #left h5 {
        font-size: 16px;
    }
    #first-section #left button {
        margin-top: 0%;
        font-size: 14px;
        padding: 15px;
        width: fit-content;
    }

    /* #first-section img {
        margin-top: 130px;
        width: 220px;
        height: 295px;
        object-fit: cover;
    } */

    #first-section #left .nb-text {
        font-size: 10px;
    }

    #first-section #right {
        display: none;
    }

    #second-section #aside {
        width: 50%;
        margin-top: 20px;
        margin-left: 20px;
        padding: 5px 9px;
        height: 430px;
    }

    #second-section #aside a {
        font-size: 14px;
        margin-top: 10px;
    }

    #second-section #aside button {
        margin-top: 12px;
        width: 130px;
        font-size: 14px;
    }

    #second-section #article {
        margin-left: 10px;
        margin-right: 20px;
    }

    #article #tentangProgram,
    #article #benefitProgram,
    #article #kurikulum,
    #article #tahapanProgram,
    #article #mentor,
    #article #biaya,
    #article #jadwalProgram,
    #article #alurPendaftaran, 
    #article #testimoni,
    #article #faq {
        margin-top: 20px;
    }

    #article #tentangProgram #isi1 {
        display: flex;
        flex-direction: column;
    }

    #article #tentangProgram #isi2 {
        display: flex;
        flex-direction: column;
        padding-left: 0;
    }

    #article #tentangProgram img {
        width: 80%;
    }

    #article #tentangProgram p {
        padding-left: 0;
    }

    #article #benefitProgram #isi {
        display: flex;
        flex-direction: column;
    }

    #article #benefitProgram #elemen {
        margin-top: 10px;
    }

    #article #benefitProgram h5 {
        font-size: 14px;
    }

    .accordion-button {
        font-size: 14px;
    }

    .accordion-body {
        font-size: 12px;
    }

    #article #benefitProgram p {
        font-size: 10px;
    }

    #article #benefitProgram img {
        width: 46px;
        height: 46px;
        object-fit: cover;
    }

    #article #kurikulum #isi,
    #article #faq #isi,
    .dropdown-content {
        width: 80%;
    }
    
    #article #kurikulum img,
    #article #faq img {
        /* margin-left: 60%; */
        width: 12px;
        height: 7px;
        margin-left: 85%;
    }
    
    #article #biaya #information h5 {
        font-size: 14px;
    }

    #article #biaya #information button {
        width: 150px;
        /* margin-left: 0; */
    }

    #article #jadwalProgram #isi,
    #article #alurPendaftaran #isi {
        display: flex;
        flex-direction: column;
    }

    #article #mentor #elemen {
        min-width: 200px;
        margin-right: 10px;
    }

    #article #mentor img {
        width: 70%;
    }
    
    #article h4 {
        width: 80%;
        /* margin-top: 20px; */
        font-size: 16px;
        font-weight: 600;
    }

    #article h3 {
        /* width: 80%; */
        font-size: 18px;
        font-weight: 700;
    }

    #article #tahapanProgram p {
        font-size: 12px;
    }

    #article p {
        font-size: 12px;
        width: 80%;
    }

    .dropdown:hover {
        margin-bottom: 200px;
    }

    .card {
        width: 100%;
        height: 200px;
        margin-left: 0;
    }

    .card-pic1 img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
    }

    .card-name h5,
    .card-name h6,
    .card-rating h6 {
        font-size: 8px;
    }

    .card-rating img {
        width: 12px;
        height: 12px;
        margin-left: 2px;
    }

    .splide__arrow {
        width: 22px;
        height: 22px;
        transform: translateY(0) !important;
    }

    .splide__arrow--next,
    .splide__arrow--prev {
        width: 22px !important;
        height: 22px;
    }
}
@media only screen and (max-width: 420px) {
    #first-section {
        padding: 0 20px;
        margin-top: 70px;
    }

    /* #first-section #left {
        padding-top: 20px;
        width: 150px;
        flex: 0%;
    } */

    /* #first-section h3 {
        font-size: 12px;
    }

    #first-section p {
        margin-top: 20px;
        font-size: 6px;
        width: 180px;
    }

    #first-section h6 {
        font-size: 6px;
        width: 130px;
    }

    #first-section #harga {
        margin-top: 0px;
    }

    #first-section h4 {
        margin-top: -5%;
        font-size: 10px;
        width: 160px;
    }

    #first-section h5 {
        font-size: 10px;
    }

    #first-section button {
        margin-top: 0%;
        font-size: 10px;
        padding: 3px;
        width: 110px;
    } */

    /* #first-section img {
        margin-top: 60px;
        width: 150px;
        height: 195px;
        object-fit: cover;
    } */
    #second-section #aside {
        width: 50%;
        margin-top: 15px;
        margin-left: 20px;
        padding: 5px 9px;
        height: 260px;
    }

    #second-section #aside a {
        font-size: 9px;
        margin-top: 7px;
    }

    #second-section #aside button {
        margin-top: 8px;
        width: 80px;
        font-size: 5px;
        padding: 5px 3px;
    }

    #second-section #article {
        margin-left: 10px;
    }

    #article #tentangProgram,
    #article #benefitProgram,
    #article #kurikulum,
    #article #tahapanProgram,
    #article #mentor,
    #article #biaya,
    #article #jadwalProgram,
    #article #alurPendaftaran, 
    #article #testimoni,
    #article #faq {
        margin-top: 15px;
    }

    #article #tentangProgram #isi1 {
        display: flex;
        flex-direction: column;
    }

    #article #tentangProgram #isi2 {
        display: flex;
        flex-direction: column;
        padding-left: 0;
    }

    #article #tentangProgram img {
        height: 60%;
        width: 60%;
    }

    #article #tentangProgram p {
        width: 85%;
    }

    #article #benefitProgram #isi {
        display: flex;
        flex-direction: column;
    }

    #article #benefitProgram #elemen {
        margin-top: 10px;
    }

    #article #benefitProgram h5 {
        font-size: 12px;
    }

    .accordion-button {
        font-size: 12px;
    }

    .accordion-body {
        font-size: 10px;
    }

    #article #benefitProgram img {
        width: 26px;
        height: 26px;
        object-fit: cover;
    }

    #article #kurikulum #isi,
    #article #faq #isi,
    .dropdown-content {
        width: 80%;
    }

    #article #kurikulum img,
    #article #faq img {
        width: 10px;
        height: 5px;
        margin-left: 60%;
    }
    #article #tahapanProgram h5 {
        font-size: 9px;
    }

    #article #tahapanProgram #isi {
        width: 90%;
    }

    #article #tahapanProgram #isi p {
        width: 100%;
        font-size: 8px;
    }

    #article #mentor img {
        height: 60px;
        width: 60px;
    }

    #article #mentor h5 {
        font-size: 12px;
    }

    #article #mentor #linkedin {
        width: 20px;
        height: 20px;
    }

    #article #biaya #isi {
        padding: 15px;
        display: block;
        text-align: center;
        /* width: 95%; */
    }

    #article #biaya #information p {
        font-size: 8px;
    }

    #article #biaya #information h5 {
        font-size: 10px;
    }

    #article #biaya #information button {
        font-size: 8px;
        width: 120px;
        /* margin: 0 10%; */
        padding: 9px 5px;
    }

    #article #biaya #information .text-discount {
        color: #FF5400;
        font-size: 8px;
        margin-top: 10px;
    }
    
    /* .img-biaya-kiri {
        display: none;
    }

    .img-biaya-kanan {
        display: block;
        width: 100px;
        margin: 0 auto;
    } */

    #article #jadwalProgram p,
    #article #alurPendaftaran p {
        font-size: 8px;
    }

    #article #jadwalProgram h5,
    #article #alurPendaftaran h5 {
        font-size: 12px;
    }

    #article #jadwalProgram #isi,
    #article #alurPendaftaran #isi {
        display: flex;
        flex-direction: column;
    }

    #article #mentor #elemen {
        min-width: 160px;
        margin-right: 10px;
    }

    #article #mentor img {
        height: 100px;
        width: 100px;
    }

    #article #faq {
        margin-bottom: 50px;
    }

    #article h4 {
        width: 90%;
        /* margin-top: 15px; */
        font-size: 10px;
        font-weight: 600;
    }

    #article h3 {
        width: 90%;
        font-size: 12px;
        font-weight: 700;
    }

    #article #tahapanProgram p {
        font-size: 12px;
    }

    #article p {
        font-size: 8px;
        width: 100%;
    }

    .dropdown #isi p {
        width: 70%;
    }

    .dropdown:hover {
        margin-bottom: 200px;
    }

    .dropdown:hover {
        margin-bottom: 200px;
    }

    .card {
        width: 100%;
        height: 200px;
        margin: 0;
    }

    .card-pic1 img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
    }

    .card-name h5,
    .card-name h6,
    .card-rating h6 {
        font-size: 8px;
    }

    .splide__arrow--next,
    .splide__arrow--prev {
        width: 14px !important;
        height: 14px;
    }

    .wrapper__splide {
        margin-top: 8px;
    }

    .card-mentor {
        height: 260px;
    }

    .card-mentor p {
        margin-bottom: 6px;
    }

    .img-biaya-kanan {
        display: block;
        width: 100px;
        margin: 0 auto;
    }

    /* .splide__pagination .is-active {
        background: #f94f25 !important;
        transform: scale(1.4) !important;
        z-index: 3 !important;
    }

    .splide__pagination__page {
        background-color: #fcab97 !important;
    } */
}
</style>
